// extracted by mini-css-extract-plugin
module.exports = {"activeOrdersWrapper":"Homepage_activeOrdersWrapper__-iji9"};